import React from "react";
import DOMPurify from "dompurify";

export type SanitizedHTMLProps = {
  html: string;
  style?: React.CSSProperties;
  forbidImages?: boolean;
  forbidTable?: boolean;
  forbidFormatting?: boolean;
};

// Use this whenever we need to output raw HTML from the API.
export default function SanitizedHTML(props: SanitizedHTMLProps): React.JSX.Element {
  let forbiddenTags = [];

  const tableExclusions = ["div", "p", "blockquote", "table", "td", "tr", "a"];

  const formattingExclusions = ["br", "b", "i", "u", "strong", "em", "span", "sup", "sub", "a"];

  if (props.forbidImages) {
    forbiddenTags.push("img");
  }

  if (props.forbidTable) {
    forbiddenTags = forbiddenTags.concat(tableExclusions);
  }

  if (props.forbidFormatting) {
    forbiddenTags = forbiddenTags.concat(formattingExclusions);
  }

  return (
    <div style={props.style} dangerouslySetInnerHTML={{__html: 
      DOMPurify.sanitize(props.html, 
        {
          USE_PROFILES: { html: true },
          FORBID_TAGS: forbiddenTags,
          ADD_TAGS: ["iframe"],
          ADD_ATTR: ["target"]
        }
    )}} />
  );
}
